module.exports = __webpack_public_path__ + "img/twitter.599f0302.png";